<template>
  <div class="blog-container">
    <nav-component></nav-component>
    <div class="blog-header">
      <div class="homepage-headline">
        <h1>The world of Unconditioned.</h1>
      </div>
    </div>
    <div class="center">
      <div class="blog-page-title">
        <h1>The Blog</h1>
      </div>
    </div>
    <div class="center posts-container">
      
      <div class="blog-post">
        <span v-if="loading">Loading...</span>
        <ul v-else-if="posts.data.length">
          <li v-for="post in posts.data" :key="post.slug" class="list-post-container">
            <router-link :to="{ name: 'post', params: { slug: post.slug } }">
              <img v-if="post.featured_image" :src="post.featured_image" class="post-img" alt="">
              <h1 class="blog-title">{{ post.title }}</h1>
              <p class="blog-date">{{ post.published | moment("MMMM YYYY") }}</p>
              <br>
            </router-link>
            <p class="read-more">{{ post.summary }}</p>
            <br>
            <router-link :to="{ name: 'post', params: { slug: post.slug } }"><p class="read-more-btn">Read More...</p></router-link>
          </li>
        </ul>
      </div>     
    </div>
    <site-map></site-map>
    <footer-component></footer-component>
  </div>
</template>


<script>
  import Butter from 'buttercms'

  const butter = Butter('f6039a406e6d49002ff904362926f123057b1f56')

  export default {
    name: 'BlogPostList',
    data () {
      return {
        loading: true,
        posts: {},
      }
    },
    methods: {
      fetchPosts () {
        butter.post.list({ page: 1, pageSize: 10 })
          .then((response) => {
            this.loading = false
            this.posts = response.data
          }).catch((response) => {
            console.log(response)
          })
      },
    },
    created () {
      this.fetchPosts()
    },
  }
</script>

<style scoped lang="scss">
  * {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    // text-align: center;
    color: #2c3e50;
  }

  .blog-header {
    width: 100%;
    height: 400px;
    display: flex;
    -webkit-flex-direction: column;
    -moz-flex-direction: column;
    -ms-flex-direction: column;
    -o-flex-direction: column;
    flex-direction: column;
    justify-content: center;
    background-image: url('../assets/img/blog-header.jpg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    margin-bottom: 30px;

    a {
      color: #fff;
      text-decoration: none;

      :active, :focus {
        outline: none !important;
      }
    }
  }
  
  .homepage-headline {
    // margin: 200px 0;

    h1 {
      font-size: 50px;
      text-align: center;
      color: #fff;
      font-family: lust, serif;
      font-weight: 400;
      font-style: normal;
      position: relative;
      top: 30px;
    }
  }

  .blog-top {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    
    .blog-categories {  }
  }

  .blog-page-title {
    width : 60%;
   align-self: flex-start;

   h1 {
     font-size: 44px;
     color: #575757;
     font-family: adobe-caslon-pro, serif;
     font-weight: 700;
     font-style: italic;
   }

   p {
     font-size: 20px;
     margin-bottom: 50px;
     font-family: brandon-grotesque, sans-serif;
     font-weight: 400;
     font-style: normal;
   }
  }

  .center {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    width: 80%;
    margin: 0 auto 40px;

    .left, .right {
      width: 50%;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;

      img, .read-more { width: 95%; }
    }
    p {
      font-family: brandon-grotesque, sans-serif;
      font-weight: 400;
      font-style: normal;
    }
    .left {
      text-align: left !important;

      .phone, .email {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 20px;

        p {
          font-size: 26px;
          color: #2e3192;
          margin: 0;
        }
      }
    }

    .blog-title {
      font-size: 26px;
      font-family: adobe-caslon-pro, serif;
      font-weight: 700;
      font-style: italic;
      line-height: 30px;
      margin-bottom: 5px;
    }

    .blog-date {
      color: #666666;
      font-size: 16px;
    }

    p.read-more-btn {
      width: 95px;
      color: #666666;
      font-size: 16px;
      border-bottom: 1px solid #fff;
      transition: all 0.125s linear;
    }
    p.read-more-btn:hover{ border-bottom: 1px solid #666666 }

    .blog-post a {
      text-decoration: none;
    }

    .icon-holder {
      background-color: #dcdded;
      width: 45px;
      height: 45px;
      border-radius: 100%; 
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 20px;

      img {
        width: 25px;
        height: 25px;
      }
    }
  }

  ul {
    padding: 0;
    list-style-type: none;
    display: flex !important;
    flex-direction: row !important;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
  }

  .blog-post li.list-post-container {
    width: 48% !important;
    box-sizing: border-box;
    margin-bottom: 30px;
  }

  .blog-post li.list-post-container p {
    margin: 0;
  }

  li, 
  .blog-post li a {
    display: flex;
    flex-direction: column;
  }

  ul li img.post-img {
    width: 100%;
  }

  @media( max-width: 775px ) {

    .blog-header {
      height: 650px;
      padding: 0 10px;
      box-sizing: border-box;
      background-image: url('../assets/img/blog-mobile.jpg');
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;

      .homepage-headline h1 { font-size: 36px !important; }
    }

    .blog-post ul { flex-direction: column !important; }

    .blog-post li.list-post-container {
    width: 95% !important;
    padding: 0;
    margin: 0 auto 40px;
  }
}
  
</style>


// WEBPACK FOOTER //
// src/components/BlogHome.vue